import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import { useStateCallback } from '@utils/stateCallback';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import PropTypes from 'prop-types'
import * as HRRequestType from '@scripts/HRRequestType';
import * as StatusCode from '@scripts/StatusCode';
import HRRequestDetailDocumentDeposit from './HRRequestDetailDocumentDeposit'
import { getAllCombos } from '@actions/HRRequest';
import { IsEnglish } from '@utils/language';
import styles from '@styles/hrRequest.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    formControl: {
        lineHeight: 2
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function HRRequestDetail(props) {
    const classes = useStyles();
    const { onClose, open, data, onReload } = props;
    const [requestData, setRequestData] = useState(props.data);
    const [requestType, setRequestType] = useStateCallback(null);
    const [requestTypes, setRequestTypes] = useStateCallback([]);
    const [description, setDescription] = useStateCallback([]);
    
    useEffect(() => {
        listCombos();
        setRequestType(props.data?.hrRequestTypeId ?? '');
        setRequestData(props.data);
        setDescription(props.data?.description ?? '');
    }, [props.data]);

    const handleClose = () => {
        onClose();
    };

    const onRequestTypeChange = (event) => {
        const value = event.target.value;

        setRequestType(value);

        setRequestData(prev => ({
            ...prev,
            hrRequestTypeId: value
        }));
    }
    const onDescriptionChange = (event) => {
        const value = event.target.value;

        setDescription(value);

        setRequestData(prev => ({
            ...prev,
            description: value
        }));
    }

    const listCombos = async () => {
        var result = await getAllCombos();
        if (result.status === StatusCode.STATUS_OK) {
            const data = JSON.parse(result.result);
            setRequestTypes(data.types);
        } else {
            // Error
            const message = i18next.t('error:generic-error')
            showMessageError(message);
        }
    }

    return (
        <React.Fragment>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} style={{ zIndex: 11002 }}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {i18next.t("hrRequest:tabPanelDetail.detailRequest")}
                            </Typography>
                        </Toolbar>
                </AppBar>
                <div className={styles.rootHRRequestPopBody}>
                    <FormControl fullWidth disabled={(props.data?.hrRequest?.hrRequestId ?? 0) > 0}>
                        <InputLabel id="label-requestType" className={"required"}>{i18next.t('hrRequest:form.requestType')}</InputLabel>
                            <Select labelId="label-requestType"
                                id="requestType"
                                value={requestType || ''}
                                onChange={onRequestTypeChange}
                                className={classes.formControl}
                                MenuProps={{ classes: { paper: styles.selectList }
                            }}>
                            {requestTypes && requestTypes.map((obj, index) =>
                                <MenuItem key={index} className={styles.selectItem} value={obj.hrRequestId}>{`${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                            )}
                        </Select>
                        <TextField label={i18next.t('hrRequest:form.description')}
                            onChange={onDescriptionChange}
                            value={description || ''}
                            className={`${classes.formControl} required`}
                            fullWidth
                            margin="normal"
                        />
                    </FormControl>
                    {requestType === HRRequestType.Type_DocumentDeposit && <HRRequestDetailDocumentDeposit data={requestData} dataRequest={requestData?.hrRequest} onClose={handleClose} onReload={onReload} />}
                </div>
            </Dialog>
        </React.Fragment >
    )
}

HRRequestDetail.propTypes = {
    data: PropTypes.object.isRequired,
    onReload: PropTypes.func
}